import { create } from 'zustand';
import { WorkOrder } from '../types/workOrders';

interface WorkOrdersState {
  loading: boolean;
  error: string | null;
  data: WorkOrder[];
  selectedAddress: string | null;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setData: (data: WorkOrder[]) => void;
  setSelectedAddress: (address: string | null) => void;
  clearWorkOrders: () => void;
}

const initialState = {
  loading: false,
  error: null,
  data: [],
  selectedAddress: null,
};

export const useWorkOrdersStore = create<WorkOrdersState>((set) => ({
  ...initialState,
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setData: (data) => set({ data }),
  setSelectedAddress: (address) => set({ selectedAddress: address }),
  clearWorkOrders: () => set(initialState),
}));